"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT = exports.BELOW = exports.ABOVE = void 0;
var ABOVE = 'ABOVE';
exports.ABOVE = ABOVE;
var BELOW = 'BELOW';
exports.BELOW = BELOW;
var DEFAULT = 'DEFAULT';
exports.DEFAULT = DEFAULT;